import { nanoid } from '@reduxjs/toolkit';

const id = nanoid();

export default function Twitter({ color = '#000000', ...props }: Record<string, unknown> & { color?: string }) {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>twitter</title>
      <defs>
        <path
          d="M22.4256003,0.193145691 C23.1806406,-0.339440618 24.192239,0.349188186 23.9736093,1.24692703 C23.6310685,2.65347058 22.9444409,3.94991003 21.9788599,5.02132259 C21.9937365,5.18329745 22.0014671,5.3463315 22.0020066,5.51030895 C22.0020066,17.3697472 10.5559398,23.4620085 0.516363648,17.8844662 C-0.404318339,17.3729762 -0.0106389431,15.9692391 1.04175123,16.0110991 C2.72835076,16.0781854 4.39795342,15.7428694 5.91616311,15.0435499 C3.71202262,13.6849506 2.30067136,11.8862895 1.60829924,9.75851181 C0.893424718,7.56158036 0.997770257,5.25288415 1.59415826,3.06028119 C1.77456266,2.39702972 1.95792376,1.89728084 2.08819503,1.60417048 C2.40386638,0.893909945 3.37366873,0.799529994 3.8203631,1.43559805 C5.491951,3.81584675 8.13498283,5.30170538 11.001725,5.51681475 C10.9863639,3.23227435 12.3906808,1.17608052 14.5274996,0.360500793 C16.4598913,-0.377053276 18.6215935,0.0411072907 20.134814,1.39534626 C20.9469085,1.09683321 21.7171835,0.692844993 22.4256003,0.193145691 Z M20.1503395,3.49783918 C19.7737087,3.61125078 19.3655742,3.49333979 19.1074524,3.19654675 C18.1491781,2.09470557 16.6049363,1.70831412 15.2406764,2.22902397 C13.8764166,2.74973383 12.9823419,4.06678046 13.0020066,5.54030895 L13.0020066,6.54030895 C13.0020066,7.08249669 12.5699333,7.52591881 12.0279277,7.53997294 C8.76719289,7.62452337 5.65195562,6.34094251 3.40606656,4.05356852 C3.01103234,5.75866021 2.98214764,7.51702981 3.51014541,9.13965711 C4.18717213,11.2202758 5.73701866,12.9093301 8.40814505,14.0964974 C9.12490821,14.4150588 9.21261237,15.3971738 8.5636365,15.8376975 C7.44453411,16.5973423 6.21832478,17.1674612 4.93400793,17.5340545 C12.6131607,19.5543029 20.0020073,14.4565164 20.002012,5.51361498 C20.0012958,5.29696781 19.9804657,5.08085507 19.9397898,4.86805943 C19.8771193,4.54019857 19.9821683,4.2026853 20.2198339,3.96830227 C20.4425963,3.74861654 20.6489193,3.51446738 20.8376958,3.26780813 C20.6111912,3.3513637 20.381972,3.42808966 20.1503395,3.49783918 Z"
          id={id}
        />
      </defs>
      <g id="🕹-Icons" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Feather" transform="translate(-613, -83)">
          <g id="twitter" transform="translate(613, 85)">
            <mask id={`mask-${id}`} fill="white">
              <use xlinkHref={`#${id}`} />
            </mask>
            <use id="Shape" fill={color} fillRule="nonzero" xlinkHref={`#${id}`} />
            <g id="🎨Color" mask={`url(#mask-${id})`} fill={color}>
              <g transform="translate(0, -2)" id="Rectangle">
                <rect x={0} y={0} width={24} height={24} />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
